import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetSocketsByDeviceId(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/socket/getSocketsByDeviceId`,
    params: params,
  });
}
